module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// /~/moment/moment.js-exposed
// module id = 0
// module chunks = 0